
import { Routes, Route } from "react-router-dom";
import Index from "@/pages/Index";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Account from "@/pages/Account";
import AccountCreated from "@/pages/AccountCreated";
import OrderConfirmation from "@/pages/OrderConfirmation";
import AdminOrders from "@/pages/AdminOrders";
import AdminProducts from "@/pages/AdminProducts";
import OrderHistory from "@/pages/OrderHistory";
import NotFound from "@/pages/NotFound";
import CGV from "@/pages/CGV";
import Confidentialite from "@/pages/Confidentialite";
import ResetPassword from "@/pages/ResetPassword";
import UpdatePassword from "@/pages/UpdatePassword";
import AdminRoute from "@/components/auth/AdminRoute";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      {/* Support both slug and ID-based URLs for backward compatibility */}
      <Route path="/product/:id" element={<Product />} />
      <Route path="/products/:slug" element={<Product />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/account" element={<Account />} />
      <Route path="/account/created" element={<AccountCreated />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/account/update-password" element={<UpdatePassword />} />
      <Route path="/order-confirmation" element={<OrderConfirmation />} />
      <Route path="/order-history" element={<OrderHistory />} />
      <Route path="/admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
      <Route path="/admin/products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
      <Route path="/cgv" element={<CGV />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
